import { render, staticRenderFns } from "./workerForm.vue?vue&type=template&id=f6c264ea&scoped=true&"
import script from "./workerForm.vue?vue&type=script&lang=js&"
export * from "./workerForm.vue?vue&type=script&lang=js&"
import style0 from "./workerForm.vue?vue&type=style&index=0&id=f6c264ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c264ea",
  null
  
)

export default component.exports